import { theme } from '@src/theme';
import { Modal } from './Modal';
import { Box, Button, Stack, Typography } from '@mui/material';
import { ReactComponent as AttentionIcon } from '@icons/Alert/attention.svg';
import { buildDataTestIdAttribute, buildFullDataTestId } from '@src/utils';

export const AttentionModal = ({ open, setIsOpen, body, applyText = 'OK', handleApply }) => {
  const dataTestId = buildFullDataTestId('modal-attention');
  return (
    <Modal
      bodySx={{ padding: 0 }}
      sxTitle={{ borderBottom: `0.5px solid ${theme.palette.warning.main}` }}
      iconTitle={<AttentionIcon />}
      title="Attention!"
      open={open}
      onCancel={() => setIsOpen(false)}
      wrapperProps={{
        PaperProps: {
          sx: {
            maxWidth: '480px',
            width: '100%',
            outline: `1px solid ${theme.palette.warning.main}`,
          },
          ...buildDataTestIdAttribute(dataTestId),
        },
      }}
    >
      <Box>
        <Typography sx={{ padding: '25px' }} color="grey.800">
          {body}
        </Typography>

        <Stack
          direction="row"
          padding="16px 24px"
          justifyContent="space-between"
          bgcolor={theme.palette.warning.main}
          width="100%"
        >
          <Button
            onClick={() => setIsOpen(false)}
            variant="outlined"
            color="secondary"
            sx={{
              justifyContent: 'center',
              mt: 5,
              minWidth: 125,
              background: 'transparent',
              borderColor: '#FFFFFF',
              margin: 0,
              color: '#FFFFFF',
              ':hover': { borderColor: '#FFFFFF', color: '#FFFFFF' },
              ':active': { borderColor: '#FFFFFF', color: '#FFFFFF' },
            }}
            {...buildDataTestIdAttribute(dataTestId, 'button-cancel')}
          >
            Cancel
          </Button>
          <Button
            onClick={handleApply}
            variant="contained"
            color="secondary"
            sx={{
              justifyContent: 'center',
              mt: 5,
              minWidth: 125,
              margin: 0,
              background: 'white',
              color: 'grey.800',
              ':hover': { color: '#4B5563', backgroundColor: '#FAFAFA' },
              ':active': { color: '#4B5563', backgroundColor: '#F3F4F6' },
            }}
            {...buildDataTestIdAttribute(dataTestId, 'button-apply')}
          >
            {applyText}
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};
